// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"1ff207e5","453":"95868835","982":"ca1f822b"}[chunkId] + ".chunk.js";
};